import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";

export default function PublicDocumentView() {
  const { token } = useParams();
  const [err, setErr] = useState("");
  const [blob, setBlob] = useState(null);
  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/documents/${token}`);
        if (!r.ok) { setErr("This link is invalid, revoked or expired."); return; }
        const b = await r.blob();
        setBlob(URL.createObjectURL(b));
      } catch { setErr("Unable to open link"); }
    })();
  }, [token]);
  return (
    <div className="min-h-screen bg-black text-white p-6">
      <div className="max-w-xl mx-auto card">
        <div className="font-bold tracking-widest text-silver border border-silver px-3 py-1 inline-block mb-3">LW&amp;Co Hub</div>
        {err ? <p className="text-amber-400">{err}</p>
             : blob ? <a className="btn-silver inline-block" href={blob} download>Download document</a>
                     : <p>Opening…</p>}
      </div>
    </div>
  );
}
